<div class="proposal-tile d-flex position-relative" [class.hoverable]="!detailsTile" [class.details-tile]="detailsTile"
     [class.transparent]="transparent"
     [class.offer-needs-action]="hasOffersNeedingAction"
     [class.tile-selected]="selected">

  <ng-container *ngIf="selected">
    <div class="selected-upper"></div>
    <div class="selected-lower"></div>
    <div class="selected-left"></div>
    <div class="selected-right"></div>
  </ng-container>

  <div *ngIf="proposalTile == null" class="d-flex justify-content-center align-items-center h-100 w-100">
    <mat-spinner class="mt-4 loading-spinner"></mat-spinner>
  </div>

  <div *ngIf="proposalTile != null" class="d-flex  h-100 w-100">

    <div class="img-container">
      <img class="lock-img cursor-help" *ngIf="proposalTile.privateProposal" src="assets/svg-icons/lock-white.svg" alt="private" matTooltip="{{'privateProposal' | translate}}" [matTooltipShowDelay]="300">
      <div class="w-100 h-100 d-flex align-items-center"
           [style]="'background-color:' + LineOfBusinessColor[lineOfBusinessIconName]+'26;'">

        <img class="lob-img" [alt]="proposalTile.lineOfBusiness"

             [src]="'assets/img/line-of-business/' + lineOfBusinessIconName + '.svg'">
      </div>
    </div>
    <div class="flex-grow-1 flex-shrink-1 flex-column d-flex justify-content-between overflow-hidden right-side">
      <div id="tile-title-row" class="d-flex justify-content-between w-100">
        <span class="dark-text normal-text proposal-name" *ngIf="proposalTile.proposalName === '' || proposalTile.proposalName == null"> {{'proposalDetails.title' | translate}} #{{proposalTile.id?.slice(0, 8)}}</span>
        <span class="dark-text normal-text proposal-name" *ngIf="proposalTile.proposalName !== '' || proposalTile.proposalName != null"> {{proposalTile.proposalName}}</span>
        <div *ngIf="!isPreview" class="d-flex justify-content-between w-35">
          <span class="light-text small-text">{{proposalTile.creationDate | dateDifference | async }}</span>

           <span *ngIf="proposalTile.lastTimeEdited != null" class="light-text small-text last-time-edited-badge">
            {{'editedProposal' | translate}}
           </span>

           <span *ngIf="hasOffersNeedingAction" class="light-text small-text offer-action-badge"
             [matTooltip]="('offerNeedsAction.' + offerActionReason + '.tooltip') | translate"
             [matTooltipShowDelay]="300">
             {{'offerNeedsAction' | translate}}
           </span>

          <span *ngIf="proposalTile.status != null" class="light-text small-text status-badge" [style.background-color]="ProposalStatusColors[statusToShow]">
            {{'createProposal.status.' + statusToShow.toLowerCase() |translate}}
          </span>
        </div>
      </div>
      <div id="tile-information-row" class="d-flex justify-content-between w-100">
        <div class="d-flex gap-2 min-width-0">
          <div class="d-flex flex-column small-container">
            <span class="light-text small-text"> {{'createProposal.sumInsured'|translate}}</span>
            <span
              class="dark-text normal-text">{{proposalTile.insuredAmount | numberFormat | async}} {{proposalTile.insuredSumType === 'VALUES_1914' ? '' : currencySymbol()}}</span>
          </div>

          <div class="d-flex flex-column ">
            <span class="light-text small-text"> {{'sorting.coverage'|translate}}</span>
            <span class="dark-text normal-text"
                   [style.color]="coverageColor()">{{proposalTile.coverage | percent}}</span>
          </div>
          <div class="d-flex flex-column flex-grow-1 w-25  line-business-container">
            <span class="light-text small-text"> {{'createProposal.lineOfBusiness'|translate}}</span>
            <span
              class="dark-text normal-text">{{'lineOfBusiness.clauses.' + proposalTile.lineOfBusiness.number + '.name' | translate}}
              <ng-container *ngIf="proposalTile.lineOfBusinessSubcategory">
                - {{proposalTile.lineOfBusinessSubcategory}}</ng-container>
            </span>
          </div>
        </div>
        <div class="min-content text-end d-flex flex-column">
          <span class="light-text small-text"> {{'deadline2'|translate}}</span>
          <span
            class="dark-text normal-text" [style.color]="deadlineColor()">{{proposalTile.deadline | date: ('dateFormatShort' | translate)}}</span>
          <span *ngIf="percentToDeadline < 10 && percentToDeadline > 0"
            class="small-text light-text deadline-info" [style.color]="deadlineColor()">{{'deadlineInfo'|translate}}</span>
        </div>

      </div>
      <div class="d-flex   justify-content-between w-100 h-100 align-items-end">
        <ng-container *ngTemplateOutlet="creator"></ng-container>
        <div class="d-flex gap-3">
          <ng-container *ngIf="!detailsTile;else createOfferButton">
            <button class="tile-button cursor-pointer blue-border"
                    *ngIf="hasOffers && permissionService.canCreateOfferForProposal(proposalTile.coverage, proposalTile.deadline) && !hideCreateOffer"
                    (click)="navigateToOffers()">
              <span class="cursor-pointer">
                {{'viewOffers'|translate}}
              </span>
              <mat-icon>arrow_forward</mat-icon>
            </button>

            <button class="tile-button cursor-pointer blue-border"
                    *ngIf="!hasOffers && permissionService.canCreateOfferForProposal(proposalTile.coverage, proposalTile.deadline) && !hideCreateOffer && ((this.user$ | async).type == Roles.ROLE_INSURER || (this.user$ | async).type == Roles.ROLE_UNDERWRITER) && (proposalTile.usersAllowedToView.length === 0 || proposalTile.usersAllowedToView.includes((this.user$ | async).id))"
                    (click)="navigateToCreateOffer()">
              <span class="cursor-pointer">
                {{'createOffer2'|translate}}
              </span>
              <mat-icon>arrow_forward</mat-icon>
            </button>

            <button class="tile-button cursor-pointer blue-border me-2"
                    *ngIf="!permissionService.canCreateOfferForProposal(proposalTile.coverage, proposalTile.deadline) && proposalTile.numberOfOffersCreated != 0 && (proposalTile.userId == (userId$|async) || (roles$ | async).includes(Roles.ROLE_BUSINESS_ADMIN) || (user$ | async).representedUsers.includes(proposalTile.userId))"
                    (click)="navigateToOffers()">
              <span class="cursor-pointer"> {{'numberOfCreatedOffers'|translate}} </span>
              <mat-icon>arrow_forward</mat-icon>
              <span class="badge cursor-help"
                    matTooltip="{{'numberOfOffersCreated' | translate: { count: proposalTile.numberOfOffersCreated } }}"
                    [matTooltipShowDelay]="1000">
                    {{proposalTile.numberOfOffersCreated}}
              </span>
            </button>
            <button class="tile-button cursor-pointer blue-border" (click)="navigateToDetails()">

              <span class="cursor-pointer">
                {{'details' | translate}}
              </span>
              <mat-icon>arrow_forward</mat-icon>
            </button>
          </ng-container>
        </div>
      </div>
    </div>

  </div>
</div>
<ng-template #creator>
  <div (click)="navigateToUserProfile(proposalTile.userId)" class="cursor-pointer-all">
    <div *ngIf="proposalTile != null" class="d-flex all-cursor-pointer user-pod">
      <img class="custom-profile-picture me-2"
           [src]="(userService.getProfilePicture(proposalTile.userId) |async) ?? 'assets/img/profile/default-profile-icon.png' "
           alt="profile"/>
      <div class="custom-profile-text d-flex flex-column justify-content-between">
        <span class="name-label">{{proposalTile.firstName}} {{proposalTile.lastName}}</span>
        <span
          class="company-label small-text">{{proposalTile.companyName}}</span>
        <div class="d-flex flex-row align-baseline">
          <span
            class="light-text small-text"
            [ngClass]="(proposalTile.seatNumber !== '')?'pe-2':''">{{proposalTile.seatNumber}}</span>
          <span
            class="light-text small-text company-role">{{'companyRole.' + proposalTile.userType |translate}}</span>
        </div>
      </div>

    </div>
  </div>

</ng-template>
<ng-template #createOfferButton>
  <ng-content></ng-content>
</ng-template>
